import React from "react";
import {
  CustomGitHubIcon,
  CustomLinkedInIcon,
  FooterContainer,
  IconLink,
  IconWrapper,
  LogoWrap,
  CopyrightWrap,
  LogoImgFooter,
} from "./StyledFooter";
import { Typography } from "@mui/material";
import myLogo from "../images/MyLogo.png";

function Footer() {
  return (
    <FooterContainer container>
      <LogoWrap container item xs={4}>
        <Typography variant="h4" fontFamily="Oswald" fontWeight="bold">
          <LogoImgFooter src={myLogo} alt="logo" />
        </Typography>
      </LogoWrap>

      <IconWrapper container item xs={4}>
        <IconLink
          href="https://www.linkedin.com/in/frontenddeveloperfullstackdeveloperwebdeveloper/"
          underline="none"
          color="disabled"
        >
          <CustomLinkedInIcon />
        </IconLink>
        <IconLink
          href="https://github.com/Zulgix"
          underline="none"
          color="disabled"
        >
          <CustomGitHubIcon fontSize="large" color="disabled" />
        </IconLink>
      </IconWrapper>

      <CopyrightWrap container item xs={4}>
        <Typography variant="body1" fontFamily="Oswald" sx={{ color: "#fff" }}>
          Copyrights © 2022 AviMiz. All rights reserved.
        </Typography>
      </CopyrightWrap>
    </FooterContainer>
  );
}

export default Footer;
